// The REAL backend routes (the C1–C8 reconciliation — NOT the aspirational §217 paths). Source of truth:
// DESIGN-STAGE0-CONTRACT-RECONCILIATION-260711.md (Xlooop-XCP-demo). /cockpit/turn and /context/assemble
// do NOT exist — never call them. Grounding (C4) is a phase of the chat turn, not a route.

export const ROUTES = {
  // C1 — chat (READ-ONLY answer about the record; never writes)
  cockpitChat: '/api/v1/cockpit-chat', // operator (owner-only) POST {scope,message,...}
  customerChat: '/api/v1/customer-chat', // customer POST {message,mode?,llm?}
  cockpitChatHistory: '/api/v1/cockpit-chat/history', // GET
  // C5 — events rail (role-redacted, authority-gated)
  events: '/api/v1/events', // GET (limit,before,project_id,status,source_tool,top_level) · POST (write)
  eventRestore: (id: string) => `/api/v1/events/${id}/restore`, // POST
  // C6 — governed decision
  signOffs: '/api/v1/sign-offs', // POST {event_id, verdict∈{approved,rejected,noted}} — WRITE, idempotent
  approvals: '/api/v1/approvals', // POST · PATCH /approvals/:id
  approval: (id: string) => `/api/v1/approvals/${id}`,
  // C2 — spine
  packets: '/api/v1/packets', // GET · POST {title, summary} — WRITE, idempotent
  // C7 — evidence
  evidence: '/api/v1/evidence', // GET · POST {kind} — WRITE, idempotent
  mcpEvidence: '/api/v1/mcp/evidence', // POST {packet_id, ...}
  // C3 — tool events
  toolEvents: '/api/v1/tool-events', // GET · POST — WRITE, idempotent
  mcpToolEvents: '/api/v1/mcp/tool-events', // POST {packet_id}
  // C8 — documents
  documents: '/api/v1/documents', // GET · POST (multipart file) — sha256 content_hash
  documentAdmissibility: (id: string) => `/api/v1/documents/${id}/admissibility`, // PATCH
  // identity / session
  session: '/api/v1/session', // GET — entitlement + identity.spine_authority
  me: '/api/v1/me',
  members: '/api/v1/members',
  // projects
  projects: '/api/v1/projects', // GET · POST {..} — WRITE
  project: (id: string) => `/api/v1/projects/${id}`, // GET · PATCH
  projectEvents: (id: string) => `/api/v1/projects/${id}/events`,
  projectSources: (id: string) => `/api/v1/projects/${id}/sources`,
  projectProvenance: (id: string) => `/api/v1/projects/${id}/provenance`,
  // plan (goals/milestones/todos/intents) — the governance-plane scope view. Backend-required (§220).
  plan: (scopeId: string) => `/api/v1/plan/${scopeId}`, // GET the scope's plan view-model
  planEntity: '/api/v1/plan/entity', // POST create — WRITE, idempotent
  planEntityById: (id: string) => `/api/v1/plan/entity/${id}`, // PATCH rename/reorder · DELETE soft-delete
  // sources / connectors
  sources: '/api/v1/sources', // GET
  connectors: '/api/v1/connectors', // GET
  sourceConnect: (provider: string) => `/api/v1/sources/connect/${provider}`, // POST
  sourceSync: (id: string) => `/api/v1/sources/${id}/sync`, // POST
  source: (id: string) => `/api/v1/sources/${id}`, // DELETE
} as const;
